import { Dispatch } from 'redux';
import axios from 'axios';
import { Action } from '../actions';
import { ActionType } from '../action-types';
import { submitApi, marketingUnsubscribe } from '../../endPointService';

const token = document.getElementsByName('__RequestVerificationToken')[0] as HTMLInputElement
  ? (document.getElementsByName('__RequestVerificationToken')[0] as HTMLInputElement).value : '';

export const isValidate = (val: boolean) => (dispatch: Dispatch<Action>) => {
  dispatch({
    type: ActionType.VALIDATE,
    payload: val,
  });
};

export const submitForm = (userFormData: any) => (dispatch: Dispatch<Action>) => {
  dispatch({
    type: ActionType.ISLOADING,
  });

  axios.post(`${submitApi}`, userFormData,
    {
      headers: {
        RequestVerificationToken: token,
        'X-Requested-with': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      if (response.status === 200 || response.status === 202 || response.status === 204) {
        dispatch({
          type: ActionType.ISFORMVISIBLE,
          payload: false,
        });
        dispatch({
          type: ActionType.ISLOADED,
        });
        dispatch({
          type: ActionType.ISSUCCESS,
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionType.ISLOADED,
      });
      dispatch({
        type: ActionType.ISFORMVISIBLE,
        payload: false,
      });
      dispatch({
        type: ActionType.ISFAILURE,
      });
    });
};

export const submitEmailPreferenceForm = (userEmailFormData: any) => (dispatch: Dispatch<Action>) => {
  dispatch({
    type: ActionType.ISLOADING,
  });
  dispatch({
    type: ActionType.ISEMAILPREFERENCE,
  });

  axios
    .post(`${marketingUnsubscribe}`, userEmailFormData, {
      headers: {
        RequestVerificationToken: token,
        'X-Requested-with': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      if (response.status === 200 || response.status === 202 || response.status === 204) {
        dispatch({
          type: ActionType.ISFORMVISIBLE,
          payload: false,
        });
        dispatch({
          type: ActionType.ISLOADED,
        });
        dispatch({
          type: ActionType.ISSUCCESS,
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionType.ISLOADED,
      });
      dispatch({
        type: ActionType.ISFORMVISIBLE,
        payload: false,
      });
      dispatch({
        type: ActionType.ISFAILURE,
      });
    });
};
